import api from '@/api';
import Context from '@/models/Context';
import Feature from '@/models/Feature';

const state = {
  isLoading: false,
  toggles: [
    'admin.users.edit',
    'pages.randomizer',
    'facebook.share.v2',
    'statistics.modern',
    'dummy.notfound'
  ]
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  }
};

const actions = {
  init({ commit, state }) {
    if (localStorage.getItem('authenticated')) {
      commit('setLoading', true);
      const domain = Context.query().first().domain;
      let queryString = '';

      state.toggles.forEach(toggle => {
        queryString +=
          (state.toggles.indexOf(toggle) === 0 ? '?' : '&') +
          `feature[]=${toggle}`;
      });

      api
        .get(`${domain}/features${queryString}`)
        .then(response => {
          Object.keys(response.data.data).forEach(key => {
            Feature.insertOrUpdate({
              data: {
                name: key,
                isEnabled: response.data.data[key]
              }
            });
          });
        })
        .then(() => {
          commit('setLoading', false);
        });
    }
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
